export default __webpack_public_path__ + "static/media/vaasstarterouro.7941c563.svg";